export default __webpack_public_path__ + "static/media/pexels-pixabay-265906.5ca7355c.jpg";